import {useCallback} from "react";

export const formatearFecha = (fechaForanea) => {
    var fecha = new Date(fechaForanea);
    var dia = fecha.getUTCDate();
    var mes = fecha.getUTCMonth() + 1;
    var anio = fecha.getUTCFullYear();

    if (dia < 10) {
        dia = '0' + dia;
    }
    if (mes < 10) {
        mes = '0' + mes;
    }

    var fechaFormateada = anio + '-' + mes + '-' + dia;
    return fechaFormateada
}
export function formateoBasico(fecha) {
    var fechaOriginal = new Date(fecha);

    // Obtener día, mes y año
    var dia = fechaOriginal.getUTCDate();
    var mes = fechaOriginal.getUTCMonth() + 1; // Los meses en JavaScript se indexan desde 0
    var año = fechaOriginal.getUTCFullYear();

    // Formatear la fecha en formato dd/mm/yyyy
    var fechaFormateada = año + '-' + (mes < 10 ? '0' : '') + mes + '-' + (dia < 10 ? '0' : '') + dia;
    return fechaFormateada;
}
export const formatearFechaGuion = (fechaForanea) => {
    var fecha = new Date(fechaForanea);
    var dia = fecha.getUTCDate();
    var mes = fecha.getUTCMonth() + 1;
    var anio = fecha.getUTCFullYear();

    if (dia < 10) {
        dia = '0' + dia;
    }
    if (mes < 10) {
        mes = '0' + mes;
    }

    var fechaFormateada = anio + "-" + mes + '-' + dia;
    return fechaFormateada
}

export const formatearFechaDeServidor = (fecha) => {
    var fechaString = fecha;
    var partesFecha = fechaString.split('/');
    var fecha = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);
    return fecha
}

export const formatearTiempo = (fecha, hora) => {
    var fechaString = fecha;
    var horaString = hora;

    // Dividir la cadena de fecha en día, mes y año
    var partesFecha = fechaString.split('/');
    var fecha = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);

    // Dividir la cadena de hora en horas, minutos y segundos
    var partesHora = horaString.split(':');
    var hora = parseInt(partesHora[0]);
    var minutos = parseInt(partesHora[1]);
    var segundos = parseInt(partesHora[2]);

    // Establecer la hora en el objeto de fecha
    fecha.setUTCHours(hora);
    fecha.setUTCMinutes(minutos);
    fecha.setUTCSeconds(segundos);

    return fecha;
}

export function FormatoMoneda(value) {
    // Comprueba si el valor es numérico
    if (isNaN(value) || value === '') {
        return "";
    }

    // Convierte el valor a un formato de dos decimales
    let formattedValue = parseFloat(value).toFixed(2);

    // Separa el valor en parte entera y decimal
    let parts = formattedValue.split('.');
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

    // Agrega separadores de miles a la parte entera
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Retorna el valor formateado con el símbolo de moneda
    return '$' + integerPart + decimalPart;
}
export const formateoDateATiempo = (fecha) => {
    var fechaActual = fecha;

    // Obtener las horas, minutos y segundos de la fecha actual
    var hora = fechaActual.getHours();
    var minutos = fechaActual.getMinutes();
    var segundos = fechaActual.getSeconds();

    // Formatear la hora en formato HH:MM:SS
    var horaFormateada = (hora < 10 ? '0' : '') + hora + ':' +
        (minutos < 10 ? '0' : '') + minutos + ':' +
        (segundos < 10 ? '0' : '') + segundos;

    return horaFormateada
}

export const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "Fecha inválida";
    const pad = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Los meses van de 0 a 11
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatOnlyDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date)) return "Fecha inválida";
    const pad = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Los meses van de 0 a 11
    const day = pad(date.getDate());

    return `${year}-${month}-${day}`;
};

export function convertirFormatoFecha(fecha) {
    // Dividir la fecha en año, mes y día
    var partesFecha = fecha.split('-');

    // Crear un objeto de fecha con los componentes
    var fechaObjeto = new Date(partesFecha[0], partesFecha[1] - 1, partesFecha[2]);

    // Obtener día, mes y año del objeto de fecha
    var dia = fechaObjeto.getUTCDate();
    var mes = fechaObjeto.getUTCMonth() + 1;
    var año = fechaObjeto.getUTCFullYear();

    // Formatear la fecha en el formato deseado20
    var fechaFormateada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + año.toString();

    return fechaFormateada;
}
// formato 2024-07-17T06:49:28.000Z
export function extraerHora(fechaHoraISO) {
    // Crear un objeto Date a partir de la cadena ISO
    const fechaHora = new Date(fechaHoraISO);

    // Obtener la hora, minutos y segundos
    const horas = fechaHora.getUTCHours();
    const minutos = fechaHora.getUTCMinutes();
    const segundos = fechaHora.getUTCSeconds();

    // Formatear la hora como HH:MM:SS
    const horaFormateada = `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segundos).padStart(2, '0')}`;

    return horaFormateada;
}
// de yyyy-mm-dd a new Date()
export function convertirAFecha(fechaStr) {
    if (!fechaStr) return null; // Manejar caso vacío
    const [year, month, day] = fechaStr.split("-").map(Number);
    return new Date(year, month - 1, day); // Restamos 1 al mes porque los meses en JS van de 0 a 11
}

export function calcularDiferenciaHoras(fechaHora1, fechaHora2) {


    // Convertir las cadenas en objetos Date
    function convertirAFecha(fechaHoraStr) {
        const [fecha, hora] = fechaHoraStr.split(" ");

        const [year, month, day] = fecha.split("-").map(Number);
        const [hours, minutes, seconds] = hora.split(":").map(Number);
       

        return new Date(year, month - 1, day, hours, minutes, seconds);
    }

    const date1 = convertirAFecha(fechaHora1);
    const date2 = convertirAFecha(fechaHora2);

   
    // Calcular la diferencia en milisegundos y convertir a horas
    const diferenciaMs = Math.abs(date2 - date1);
    const diferenciaHoras = diferenciaMs / (1000 * 60 * 60);

    return diferenciaHoras;
}


export function obtenerMartesYMiercoles(fecha) {
    const diaSemana = fecha.getDay();

    // Obtener el miércoles más cercano (de la semana actual o pasada según el día de la semana)
    const miercolesActual = new Date(fecha);
    if (diaSemana <= 2) {
        // Si es lunes o martes, tomamos el miércoles de la semana pasada
        miercolesActual.setDate(fecha.getDate() - (diaSemana + 4)); // Restamos los días para ir al miércoles pasado
    } else {
        // Si es miércoles o después, tomamos el miércoles de esta semana
        miercolesActual.setDate(fecha.getDate() - (diaSemana - 3)); // Ajustar para el miércoles de la semana actual
    }

    // Obtener el martes de la siguiente semana (2 = Martes)
    const martesSiguiente = new Date(miercolesActual);
    martesSiguiente.setDate(miercolesActual.getDate() + 6); // Saltar a la siguiente semana (miércoles + 6 días = martes)

    // Formatear las fechas en 'yyyy-MM-dd'
    // const formatearFecha = (fecha) => fecha.toISOString().split('T')[0];

    return {
        miercolesActual: miercolesActual,
        martesSiguiente: martesSiguiente,
    };

}

// 2024-07-24T00:00:00.000Z    de uso a dd/mm/yyyy
export const convertirFechaIsoAFormato = (isoDate) => {
    // Crear un objeto Date a partir del string ISO 8601
    const date = new Date(isoDate);

    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
        throw new Error("Fecha ISO no válida");
    }

    // Obtener los componentes de la fecha
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1; // Los meses en JavaScript son de 0 a 11
    const year = date.getUTCFullYear();

    // Formatear la fecha como "dd/mm/yyyy"
    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');
    const formattedDate = `${formattedDay}/${formattedMonth}/${year}`;

    return formattedDate;
};

// RECIBE ALGO COMO ESTO 07:15:00 Y SALE UN OBJETO TIPO New Date()
export const horaStringAHoraDate = (horaStr) => {
    const [hh, mm, ss] = horaStr.split(":").map(Number);
    const date = new Date();
    date.setHours(hh);
    date.setMinutes(mm);
    date.setSeconds(ss || 0);
    date.setMilliseconds(0);
    return date;
};

// de iso "2025-06-20T00:00:00.000Z" a New Date()
export const isoAFechaLocal = (isoStr) => {
    // Extrae solo la parte de la fecha sin la hora
    const [year, month, day] = isoStr.split("T")[0].split("-").map(Number);
    return new Date(year, month - 1, day); // Mes en Date es base 0
};

// recibe una fecha tipo new Date y la transforma a yyyy-mm-dd HH:mm:ss
export const formatearFechaHora = (date) => {
    if (!(date instanceof Date) || isNaN(date)) return "";

    const pad = (num) => num.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Los meses van de 0 a 11
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export function obtenerFechasUltimos30Dias() {
    const ahora = new Date();

    // Fecha fin: hoy a las 23:59:59
    const fechaFin = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate(),
        23, 59, 59
    );

    // Fecha inicio: hace 30 días a las 00:00:00
    const fechaInicio = new Date(
        ahora.getFullYear(),
        ahora.getMonth(),
        ahora.getDate() - 30,
        0, 0, 0
    );

    return {
        fechaInicio,
        fechaFin
    };
}

export const formatTimeToString = (date) => {
    if (!date) return null;
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
};

/**
 * Formatea un horario de tipo "1970-01-01T09:59:00.000Z" a "HH:mm".
 */
export const formatearHora = (isoString) => {
    if (!isoString) return '';

    const date = new Date(isoString);

    const horas = String(date.getUTCHours()).padStart(2, '0');
    const minutos = String(date.getUTCMinutes()).padStart(2, '0');

    return `${horas}:${minutos}`;
};

/**
 * Convierte un string 'HH:mm:ss' a Date válida para Calendar (timeOnly)
 * Limpia espacios y valida formato
 */
export const parseTimeStringToDate = (timeString) => {
    if (!timeString || typeof timeString !== 'string') return null;

    const cleanTime = timeString.trim();
    const parts = cleanTime.split(':').map(Number);

    // Acepta HH:mm o HH:mm:ss
    if ((parts.length < 2 || parts.length > 3) || parts.some(Number.isNaN)) {
        console.warn('Hora inválida:', timeString);
        return null;
    }

    const [hours, minutes, seconds = 0] = parts;

    const date = new Date();
    date.setHours(hours, minutes, seconds, 0);

    return date;
};


export const parseDate = (dateString) => {
    if (!dateString) return null;

    try {
        const parsedDate = new Date(dateString);

        return new Date(
            parsedDate.getUTCFullYear(),
            parsedDate.getUTCMonth(),
            parsedDate.getUTCDate()
        );
    } catch (error) {
        console.error('Error parsing date:', error);
        return null;
    }
};

/**
 * Combina una fecha base con la hora de otra fecha/hora
 * y retorna en formato "YYYY-MM-DD HH:mm"
 *
 * @param {string|Date} fechaBase - Fecha que se usará (puede ser "10/10/2025" o Date)
 * @param {string|Date} fechaConHora - Fecha/hora de donde se extraerá la hora (puede ser "10/10/2025 13:00:00" o Date)
 * @returns {string} Fecha y hora combinadas en formato "YYYY-MM-DD HH:mm"
 *
 * @example
 * combinarFechaYHora("11/10/2025", "10/10/2025 13:00:00")
 * // Retorna: "2025-10-11 13:00"
 */
export const combinarFechaYHora = (fechaBase, fechaConHora) => {
    // Convertir a objetos Date si son strings
    const fecha = typeof fechaBase === 'string' ? new Date(fechaBase) : fechaBase;
    const hora = typeof fechaConHora === 'string' ? new Date(fechaConHora) : fechaConHora;

    // Crear nueva fecha con la fecha base
    const resultado = new Date(fecha);

    // Establecer la hora de la segunda fecha
    resultado.setHours(hora.getHours());
    resultado.setMinutes(hora.getMinutes());
    resultado.setSeconds(0);
    resultado.setMilliseconds(0);

    // Formatear a "YYYY-MM-DD HH:mm"
    const año = resultado.getFullYear();
    const mes = String(resultado.getMonth() + 1).padStart(2, '0');
    const dia = String(resultado.getDate()).padStart(2, '0');
    const horas = String(resultado.getHours()).padStart(2, '0');
    const minutos = String(resultado.getMinutes()).padStart(2, '0');

    return `${año}-${mes}-${dia} ${horas}:${minutos}`;
};

/**
 * Convierte una hora en formato "HH:mm" o "HH:mm:ss" a un objeto Date
 * que los componentes Calendar de PrimeReact pueden consumir.
 */
export const parsearHoraADate = (horaStr) => {
    if (!horaStr) return null;
    if (horaStr instanceof Date) return horaStr;

    let horas, minutos;

    // Si es un string ISO (e.g. "1970-01-01T09:15:00.000Z"), extraer hora y minutos del string directamente
    if (horaStr.includes('T')) {
        const timePart = horaStr.split('T')[1]; // "09:15:00.000Z"
        const partes = timePart.split(':');
        horas = parseInt(partes[0], 10) || 0;
        minutos = parseInt(partes[1], 10) || 0;
    } else {
        // Formato "HH:mm" o "HH:mm:ss"
        const partes = horaStr.split(':');
        horas = parseInt(partes[0], 10) || 0;
        minutos = parseInt(partes[1], 10) || 0;
    }

    const fecha = new Date();
    fecha.setHours(horas);
    fecha.setMinutes(minutos);
    fecha.setSeconds(0);
    fecha.setMilliseconds(0);
    return fecha;
};

export const formatearHoraAmPm = (hora) => {
    if (!hora) return "—";
    const [h, m] = hora.split(":");
    const hNum = parseInt(h, 10);
    const ampm = hNum >= 12 ? "PM" : "AM";
    const h12  = hNum === 0 ? 12 : hNum > 12 ? hNum - 12 : hNum;
    return `${h12}:${m} ${ampm}`;
};

export const obtenerLunesADomingo = () => {
    const fecha = new Date();
    const diaSemana = fecha.getDay();
    const lunes = new Date(fecha);
    lunes.setDate(fecha.getDate() - diaSemana + (diaSemana === 0 ? -6 : 1)); // Si es domingo, retrocede 6 días
    const domingo = new Date(lunes);
    domingo.setDate(lunes.getDate() + 6);
    return { lunes, domingo };
};

export function formatearMiles(numero) {
    return Number(numero).toLocaleString('en-US');
}